var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"weekday-selector"},[_c('b-button-group',_vm._l((_vm.days),function(day){return _c('b-button',{key:day.value,staticClass:"day-btn",class:{ active: _vm.selectedDays.includes(day.value) },attrs:{"pill":""},on:{"click":function($event){return _vm.toggleDay(day.value)}}},[_vm._v(" "+_vm._s(day.label)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }